module.exports = __webpack_public_path__ + "static/media/mn.f738be9c.svg";